import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  pageNotFound: {
    fontSize: 'xx-large',
    textAlign: 'center',
    margin: theme.whitespace?.most
  }
}));

// Display empty message
const NotFound = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  return <div className={classes.pageNotFound}>{t('common.pageNotFound')}</div>;
};
export default NotFound;
